<section class="cui-dialog preview-dialog">
  @let item = currentItem();
  <header class="cui-dialog__header preview-header">
    <div>
      <h1>{{ data.contextTitle }} | {{ item.displayName }}</h1>
      @if (data.items.length > 1) {
        <span class="preview-counter">{{ currentIndex() + 1 }} of {{ data.items.length }}</span>
      }
    </div>
    <cui-dialog-close-button></cui-dialog-close-button>
  </header>

  <div class="cui-dialog__content preview-content">
    @switch (item.kind) {
      @case ('value') {
        <div class="preview-value">{{ valueText(item.value) }}</div>
      }
      @case ('text') {
        <div class="preview-text" [innerText]="item.text"></div>
      }
      @case ('image') {
        <img [src]="item.src" [alt]="item.displayName" class="preview-image" />
      }
      @case ('file') {
        <div class="preview-file">
          <span class="material-symbols-outlined preview-file__icon" aria-hidden="true">
            description
          </span>
          <span class="preview-file__name">{{ item.fileName }}</span>
        </div>
      }
      @case ('file-loading') {
        @if (item.image) {
          <div class="preview-image-loading" aria-label="Loading image"></div>
        } @else {
          <div class="preview-file" aria-label="Loading file">
            <span class="preview-file-icon-loading"></span>
            <span class="preview-file-name-loading">
              <span>{{ item.fileName }}</span>
            </span>
          </div>
        }
      }
      @case ('table') {
        <div class="preview-table">
          <app-dynamic-table
            [allowEdit]="false"
            [columns]="item.columnDef"
            [data]="item.tableData"></app-dynamic-table>
        </div>
      }
      @case ('graph') {
        <app-graph class="preview-graph" [chartOptions]="item.options"></app-graph>
      }
    }

    @if (item.description) {
      <p class="preview-description">{{ item.description }}</p>
    }

    @if (downloadUnavailableMessage(item); as message) {
      <p class="download-unavailable">{{ message }}</p>
    }
  </div>

  @if (data.items.length > 1 || canDownload(item)) {
    <footer class="cui-dialog__actions preview-actions">
      <div class="preview-footer-actions">
        @if (currentDownload(); as download) {
          <a cuiButton [download]="download.fileName" [href]="download.url">
            <span class="material-symbols-outlined" aria-hidden="true">download</span>
            Download
          </a>
        }

        @if (data.items.length > 1) {
          <button cuiButton variant="plain" type="button" (click)="previous()">
            <span class="material-symbols-outlined" aria-hidden="true">chevron_left</span>
            Previous
          </button>
          <button cuiButton variant="plain" type="button" (click)="next()">
            Next
            <span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>
          </button>
        }
      </div>
    </footer>
  }
</section>
